import { useQuery } from '@tanstack/react-query';
import type { SchoolLevel } from '@jeraisonne/db';
import { supabase } from '@/lib/supabase';
import { getDailyExercise } from '@/lib/student-objectives/daily-exercise';
import { useInProgressAttemptIds } from '@/lib/exercises/use-in-progress-attempts';
import { useAuth } from '@/lib/auth';
import { DailyExerciseCard } from './daily-exercise-card';

interface Props {
  studentLevel: SchoolLevel;
  onStart: (exerciseId: string) => void;
  /** Exercice en cours d'ouverture (spinner sur son bouton). */
  pendingExerciseId?: string | null;
}

export function DailyExerciseSection({ studentLevel, onStart, pendingExerciseId = null }: Props) {
  const today = new Date().toISOString().slice(0, 10);
  const { user } = useAuth();

  const { data: exercise, isLoading } = useQuery({
    queryKey: ['daily-exercise', studentLevel, today],
    queryFn: () => getDailyExercise(supabase, studentLevel),
    staleTime: 60 * 60 * 1000,
  });

  const { data: inProgressIds = [] } = useInProgressAttemptIds(user?.id ?? '');

  return (
    <section className="space-y-3">
      <h2 className="font-display text-ink-900 flex items-center gap-2 text-lg font-bold">
        <span aria-hidden>☀️</span>
        <span>Exercice du jour</span>
      </h2>
      <DailyExerciseCard
        exercise={exercise ?? null}
        isLoading={isLoading}
        onStart={onStart}
        isStarting={!!exercise && pendingExerciseId === exercise.exerciseId}
        inProgress={!!exercise && inProgressIds.includes(exercise.exerciseId)}
      />
    </section>
  );
}
